import * as React from 'react';
import { SVGProps } from 'react';

const IconMBUSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 2V1H3v1h.635l-.931 5H1v1h1v3h1V8h6v3h1V8h1V7h-1V5H8v2h-.704l-.931-5H7ZM5.571 3H4.43L3.73 7h2.54L5.57 3Z"
    />
  </svg>
);
export default IconMBUSizeXs;
